import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { budgetDataToMonthGraph } from './budgetHelpers';

const BudgetGraph = ({ data, budget, onClick }) => {
  const [actualPoints, expectedPoints, budgetLinePoints] = useMemo(
    () => budgetDataToMonthGraph(data, budget),
    [data, budget],
  );

  if (!data) return null;

  return (
    <svg
      onClick={onClick}
      width="100%"
      height="100%"
      viewBox="0 0 240 100"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames('budget-graph', { clickable: onClick !== undefined })}
    >
      <defs>
        <pattern
          id="stripes"
          patternUnits="userSpaceOnUse"
          width="20"
          height="100%"
          patternTransform="rotate(0)"
        >
          <line x1="0" y1="0" x2="0" y2="100%" stroke="#959699" strokeWidth="1" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="rgba(255,255,255,0.2)" />
      <rect width="100%" height="100%" fill="url(#stripes)" />
      <polyline
        points={budgetLinePoints}
        stroke="#76a6af"
        strokeDasharray="4"
        strokeWidth="1"
        fill="none"
        vectorEffect="non-scaling-stroke"
      />
      {/* Expected budget */}
      <polyline
        points={expectedPoints}
        stroke="#ffaa21"
        strokeWidth="2"
        fill="none"
        vectorEffect="non-scaling-stroke"
      />
      {/* Actuals per month */}
      <polyline
        points={actualPoints}
        stroke="#0060ff"
        strokeWidth="2"
        fill="none"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
};

BudgetGraph.propTypes = {
  data: PropTypes.arrayOf(PropTypes.number),
  budget: PropTypes.number,
  onClick: PropTypes.func,
};
BudgetGraph.defaultProps = {
  data: [],
  budget: 0,
  onClick: undefined,
};
export default BudgetGraph;
